export const MobilitätsbehinderungDescription = `
# Folgende Mindeststandards für mobilitätsbehinderte Menschen sind gewährleistet
- Zugang: Stufenlos, mit Rampe oder Treppenlift (auch für Elektrorollstühle befahrbar).
- Toilette: Neben dem Toilettenbecken besteht eine Bewegungsfläche von 95 x 70 cm und vor dem Toilettebecken von 150 x 150 cm und es gibt klappbare Haltegriff links und rechts.
`

export const GehörlosDescription = `
# Folgende Mindeststandards für gehörlose Menschen sind gewährleistet
- Veranstaltungen finden in Gebärdensprache statt oder Gebärdensprachdolmetscher_innen werden bei Bedarf gestellt.
- Veranstaltungen finden in Gebärdensprache statt oder Gebärdensprachdolmetscher_innen werden bei Bedarf gestellt.
`

export const HörbehinderungDescription = `
# Folgende Mindeststandards für schwerhörige Menschen sind gewährleistet
- Eine Induktionsanlage oder FM-Anlage ist vorhanden und funktionsbereit.
- Liturgen sprechen mit dem Gesicht zur Gemeinde
`

export const SehbehinderungDescription = `
# Folgende Mindeststandards für sehbehinderte Menschen sind gewährleistet
- Glastüren sind nicht vorhanden oder - wenn vorhanden - in Augenhöhe kontrastoptimiert markiert.
- Treppen sind nicht vorhanden oder - wenn vorhanden - mit mindestens einem Handlauf versehen.
- Es besteht die Möglichkeit, einen Fahrdienst oder eine Begleitung anzufordern.
- Im Gottesdienst werden die Liednummern angesagt.
`

export const GeistigeBehinderungDescription = `
# Folgende Mindeststandards für geistig behinderte und demente Menschen sind gewährleistet
- Es werden Angebote für geistig behinderte und demente Menschen bereitgehalten.
- Es besteht die Möglichkeit, einen Fahrdienst oder eine Begleitung anzufordern.
- Informationen werden in einfacher Sprache weitergegeben
`

export const ImpressumMarkdown = `
# Impressum
## Herausgeber

Evangelische Kirche Berlin-Brandenburg-schlesische Oberlausitz  
Georgenkirchstraße 69  
10249 Berlin  
Tel: +49 (0) 30 24344-121  
[Kontakt](mailto:info@ekbo.de)

[Konsistorialpräsident Dr. Jörg Antoine](https://www.ekbo.de/wir/konsistorium/praesident.html)  
[Propst Dr. Christian Stäblein](https://www.ekbo.de/wir/propst.html)  
 
## Redaktion (gemäß § 55 Abs. 2 RStV) 

Internetbeauftragte  
**Annette Kaiser**  
Tel: +49 (0) 30 24344-283  
[a.kaiser(at)ekbo.de](mailto:a.kaiser@ekbo.de)

Internetbeauftragter  
**Hans-Christian Bandholz**  
Tel: +49 (0) 30 24344-283  
[hc.bandholz(at)ekbo.de](mailto:hc.bandholz@ekbo.de)

Referentin für Öffentlichkeitsarbeit  
**Amet Bick**  
Tel: +49 (0) 30 24344-328  
[bick(at)wichern.de](mailto:bick@wichern.de)
 

Die Evangelische Kirche Berlin-Brandenburg-schlesische Oberlausitz ist eine Körperschaft des öffentlichen Rechts. Sie wird in allgemeinen Angelegenheiten durch den Präsidenten Dr. Jörg Antoine vertreten.

### Texte
Evangelische Kirche Berlin-Brandenburg-schlesische Oberlausitz

### Bilder
Annette Kaiser, EKBO | Thorsten Wittke, EKBO | Pixelio | Pixabay | Nordsonne Identity

Das Copyright liegt bei der EKBO oder bei Dritten. Eine weitere Verwendung ist nicht, bzw. nur nach Rücksprache, möglich.

### Hosting | Programmierung | Design:
Unique (Deutschland) GmbH  
Wandsbeker Stieg 41  
22087 Hamburg  
`

/*
### Hosting:  
Mittwald CM Service GmbH & Co. KG  
Königsberger Straße 6  
32339 Espelkamp  

### Programmierung:  
DMK E-BUSINESS GmbH  
Stefan-Heym-Platz 1  
09111 Chemnitz  

### Design:
Nordsonne Identity GmbH  
Linienstraße 153  
10115 Berlin  
*/

export const DatenschutzMarkdown = `
# Datenschutzerklärung
Datenschutz ist leider nicht selbstverständlich. Die EKBO ist aber um den Schutz Ihrer persönlichen Daten bemüht und diese Seite soll im folgenden transparenter machen, wie mit Ihren uns überlassenen persönlichen Daten umgegangen wird. Die ständige Optimierung unserer Webseite liegt uns sehr am Herzen. Daher werden rechnerbezogene Daten gespeichert, um Trends zu verzeichnen und Statistiken zu erstellen. Diese gespeicherten Daten dienen auch zu Zwecken der Identifikation und Nachverfolgung unzulässiger Zugriffsversuche auf unseren Webserver. Daher werden protokollierte Daten gespeichert und im Falle eines unerlaubten Zugriffs ausgewertet. Die Auswertung erfolgt durch Mitarbeitende der EKBO. Wir haben alle Mitarbeitende auf die Datenschutzvorschriften hingewiesen und auf ihre Einhaltung verpflichtet.

Das [Datenschutzgesetz der Evangelischen Kirche in Deutschland](https://www.kirchenrecht-ekd.de/document/39740) gibt Usern verschiedene Möglichkeiten, den Umgang mit den jeweiligen personenbezogenen Daten durch Auskunft und Benachrichtigung selbst zu überprüfen und durch Berichtigung, Löschung und Sperrung von Daten selbst zu beeinflussen. **Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Bitte wenden Sie sich hierfür an unsere Service-Adresse: [homepage-service(at)ekbo.de](mailto:homepage-service@ekbo.de).**

## Fragen zum Datenschutz
Bei Fragen zum Datenschutz wenden Sie sich bitte an den/die örtliche Datenschutzbeauftragte:

Konsistorium der Evangelischen Kirche-Berlin-Brandenburg-schlesische Oberlausitz  
Georgenkirchstraße 69  
10249 Berlin  
Telefon: 030 24344 510  

## Für die Datenschutzaufsicht ist zuständig:
Der Beauftragte für den Datenschutz der Evangelischen Kirche in Deutschland

Außenstelle Berlin  
Invalidenstraße 29  
D-10115 Berlin  
Tel. +49 (0) 30 2005157-0  
Fax +49 (0) 30 2005157-20  
E-Mail: [ost(at)datenschutz.ekd.de](mailto:ost@datenschutz.ekd.de)  
Internet: https://datenschutz.ekd.de/datenschutz/  
### Aktiv Komponenten (Cookies u.a.)
Im gesamten Informationsangebot der EKBO werden keine Java-Applets oder Active-X-Controls verwendet, JavaScript nur falls nötig. Cookies werden gesetzt, um die Funktionalität der Schriftgrößenveränderung zu speichern, sie enthalten keine personenbezogene Daten und werden nicht ausgewertet. Wenn Sie Cookies ausschalten, kann die Schriftgröße nur über den Browser verändert werden. Foren, bei denen sich die Nutzer anmelden können, nutzen ebenfalls Cookies. Der Nutzer kann selbst entscheiden, ob dieser Cookie permanent gespeichert oder nach jeder Session gelöscht wird.
Die meisten Browser sind so eingestellt, dass sie Cookies automatisch akzeptieren. Sie können Ihren Browser so einstellen, dass er Sie über die Platzierung von Cookies informiert. So wird der Gebrauch von Cookies für Sie transparenter. Sie können die Installation der Cookies auch durch eine entsprechende Einstellung Ihrer Browser-Software verhindern.
### Protokollierung

Bei jedem Zugriff auf die Website werden aus oben erwähnten sicherheitstechnischen und statistischen Gründen relevante Zugriffsdaten gespeichert. Nutzerprofile werden nicht erstellt. Eine Weitergabe an Dritte, auch in Auszügen, findet nicht statt.
Je nach verwendetem Zugriffsprotokoll beinhaltet der Protokolldatensatz Angaben mit folgenden Inhalten:

- IP-Adresse des anfordernden Rechners
- Datum und Uhrzeit der Anforderung,
- vom anfordernden Rechner gewünschte Zugriffsmethode/Funktion,
- vom anfordernden Rechner übermittelte Eingabewerte (z.B. Formulareinträge)
- Zugriffsstatus des Web-Servers (Datei übertragen, Datei nicht gefunden, Kommando nicht ausgeführt...),
- Name der angeforderten Datei (URL) sowie ggf. Netzwerkpfade, von dem aus die Datei angefordert beziehungsweise die gewünschte Funktion veranlasst wurde (Referrer).

Sofern innerhalb des Internetangebotes die Möglichkeit zur Eingabe persönlicher oder geschäftlicher Daten (zum Beispiel im Rahmen einer persönlichen Registrierung, Bestellung, Anforderung oder Mitteilung) besteht, so erfolgt die Angaben dieser Daten seitens des Besuchers auf ausdrücklich freiwilliger Basis.
### E-Mail-Sicherheit
Wenn Sie uns eine E-Mail senden, so wird Ihre E-Mail-Adresse nur für die Korrespondenz mit Ihnen verwendet.
### Links
Unser Web-Angebot enthält Links zu anderen Websites. Wir haben keinen Einfluss auf deren Inhalte und darauf, dass deren Betreiber die Datenschutzbestimmungen einhalten.
### Social-Media-PlugIns
Unsere Unterseiten setzen teilweise Social-Media-PlugIns ein (YouTube und Twitter). Hierbei werden personenbezogene Daten der User an die Anbieter dieser Dienste (also die in den USA registrierten Firmen [Google LLC](https://de.wikipedia.org/wiki/Google_LLC) und [Twitter Inc.](https://de.wikipedia.org/wiki/Twitter)) weitergeleitet (zumindest IP-Adressen). Wir arbeiten zur Zeit an der Minimierung und wollen in Zukunft die Inhalte aus sozialen Medien ganz ohne das Einbinden dieser PlugIns erreichen. Auf unserer Startseite werden keine Social-Media-PlugIns eingesetzt.
### Google Maps
Diese Webseite verwendet das Produkt Google Maps von Google Inc zur Routenplanung. Google Maps wird von Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA betrieben. Durch Nutzung dieser Webseite erklären Sie sich mit der Erfassung, Bearbeitung sowie Nutzung der automatisiert erhobenen Daten durch Google Inc, deren Vertreter sowie Dritter einverstanden. 
Die Nutzungsbedingungen von Google Maps finden Sie hier: [www.google.com/intl/de_de/help/terms_maps.html](www.google.com/intl/de_de/help/terms_maps.html)
### Nutzung persönlicher Daten und Zweckbindung
Alle im Rahmen der Internetdienste anfallenden personenbezogenen Daten werden entsprechend den jeweils geltenden Vorschriften zum Schutz personenbezogener Daten, nur zum Zweck dieser Dienstleistung und zur Wahrung berechtigter eigener Interessen im Hinblick auf die Information, Beratung und Betreuung unserer Besucher und einer bedarfsgerechten Angebotsgestaltung erhoben, verarbeitet und genutzt. Die EKBO wird personenbezogene Daten an auskunftsberechtigte Institutionen (Behörden) übermitteln, wenn die EKBO durch Rechtsvorschriften oder per Gerichtsbeschluss dazu verpflichtet ist. Sofern dieses nicht gerichtlich untersagt ist, werden wir Sie über diese Übermittlung in Kenntnis setzen.
### Newsletter
Wenn Sie sich mit Ihrer E-Mail-Adresse für unseren Newsletter angemeldet haben, nutzen wir Ihre E-Mail-Adresse, bis Sie sich vom Newsletter-Bezug abmelden. 
Diese  Daten werden aus dem Kontaktformular und bei der Anmeldung für den Erhalt des Newsletters gespeichert: 

- Vorname (optional)
- Name (optional)
- E-Mail-Adresse 

Die Anmeldung zu unserem Newsletter erfolgt in einem sog. Double-Opt-In-Verfahren. D.h. Sie erhalten nach der Anmeldung eine E-Mail, in der Sie um die Bestätigung Ihrer Anmeldung gebeten werden. Diese Bestätigung ist notwendig, damit sich niemand mit fremden E-Mail-Adressen anmelden kann. Die Anmeldungen zum Newsletter werden protokolliert, um den Anmeldeprozess entsprechend den rechtlichen Anforderungen nachweisen zu können. Hierzu gehört die Speicherung des Anmelde- und des Bestätigungszeitpunkts, als auch der IP-Adresse. 
Sie können den Empfang unseres Newsletters jederzeit kündigen, d.h. Ihre Einwilligungen widerrufen. Einen Link zur Kündigung des Newsletters finden Sie am Ende eines jeden Newsletters. Wenn Sie Ihre  Anmeldung gekündigt haben, werden ihre personenbezogenen Daten gelöscht. 
### Kontaktformular
Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter. 
### Sicherheit
Die EKBO setzt technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre zur Verfügung gestellten Daten durch zufällige oder vorsätzliche Manipulationen oder den Zugriff unberechtigter Personen zu schützen. Unsere Sicherheitsmaßnahmen werden entsprechend der technologischen Entwicklung fortlaufend verbessert.
### Änderungen
**Wir behalten uns vor, die Datenschutzerklärung zu ändern, um sie an geänderte Rechtslagen, oder bei Änderungen des Dienstes sowie der Datenverarbeitung anzupassen. Dies gilt jedoch nur im Hinblick auf Erklärungen zur Datenverarbeitung. Sofern Einwilligungen der Nutzer erforderlich sind oder Bestandteile der Datenschutzerklärung Regelungen des Vertragsverhältnisses mit den Nutzern enthalten, erfolgen die Änderungen nur mit Zustimmung der Nutzer. Die Nutzer werden gebeten sich regelmäßig über den Inhalt der Datenschutzerklärung zu informieren.**
`



// WEBPACK FOOTER //
// ./src/Descriptions.js